var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldDerived = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.988 10.809-1.031 4.84c-.184.867-.57 1.576-1.16 2.126-.59.551-1.197.827-1.822.827-.344 0-.597-.066-.76-.197a.61.61 0 0 1-.242-.495.7.7 0 0 1 .152-.445c.102-.13.248-.194.44-.194.12 0 .227.028.319.082a.978.978 0 0 1 .243.206c.055.066.116.156.185.27l.178.292c.301-.023.558-.226.77-.61.214-.382.398-.929.554-1.64l1.079-5.062H4.75l.123-.534h1.13l.083-.398c.094-.453.242-.861.445-1.225.203-.363.434-.672.692-.925.254-.25.542-.447.864-.59.322-.142.632-.213.929-.213.343 0 .596.065.758.196a.61.61 0 0 1 .244.495.727.727 0 0 1-.144.446c-.096.128-.245.193-.448.193a.614.614 0 0 1-.317-.08.895.895 0 0 1-.24-.207 1.921 1.921 0 0 1-.187-.276 3.843 3.843 0 0 0-.176-.287c-.27.012-.508.19-.715.534-.207.343-.395.916-.562 1.716l-.13.621H8.57l-.123.534H6.988Zm2.225 2.261c0-1.758.45-3.183 1.387-4.424h.713c-.694.89-1.236 2.774-1.236 4.424 0 1.66.537 3.54 1.236 4.429H10.6c-.938-1.24-1.387-2.666-1.387-4.429Zm5.288.957h-.078l-1.25 1.988h-.952l1.802-2.632L12.2 10.75h1.001l1.25 1.958h.078l1.236-1.958h.952l-1.787 2.598 1.811 2.666h-.996l-1.245-1.988Zm5.23-.952c0 1.758-.45 3.184-1.387 4.424h-.713c.693-.889 1.235-2.773 1.235-4.424 0-1.66-.537-3.54-1.235-4.429h.713c.937 1.24 1.386 2.666 1.386 4.43Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldDerived);
export default ForwardRef;